<template>
  <div class="wrapper">
    <div class="tilte-text">API订单 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <Select v-model="searchForm.order_status" style="width:150px" placeholder="全部状态">
          <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
      <template>
        <Input v-model="searchForm.order_id" placeholder="守兔订单编号" style="width: 150px;" />
      </template>
      <template>
        <Input v-model="searchForm.third_order_id" placeholder="第三方订单编号" style="width: 150px;" />
      </template>
      <template>
        <Select v-model="searchForm.app_key"
                style="width:150px"
                placeholder="全部推广位"

        >
          <Option v-for="item in appList"
                  :value="item.value"
                  :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
      <template>
        <span>下单日期</span>
        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;" @on-change="handelDateChangeStart">
        </DatePicker>
        <span>至</span>
        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak" @on-change="handelDateChange">
        </DatePicker>
      </template>
      <template>
        <Select v-model="searchForm.interceptStatus" style="width:150px" placeholder="拦截状态">
          <Option v-for="item in interceptStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <div class="flex" style="margin-top: 10px">
          <span class="search-text">下单订单类型</span>
          <el-radio-group style="margin-left: 10px" v-model="searchForm.orderType" @input="selectType">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">特惠单</el-radio>
<!--            <el-radio :label="2">竞价单</el-radio>-->
            <el-radio :label="3">秒出单</el-radio>
          </el-radio-group>
          <Button type="text" style="background: #FF8622;color: #FFFFFF;margin-left: 10px" @click="handleFilter">查询</Button>
          <Button type="text" style="background: #FF8622;color: #FFFFFF;margin-left: 10px" @click="reset">重置</Button>
<!--          <Button type="text" style="border: 1px solid #FF8622; color: #FF8622;margin-left: 10px" @click="downReport">下载报表</Button>-->
        </div>
      </template>
      <template>

      </template>
    </div>
    <div class="table-wrapper">
      <Table border :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
        <template slot-scope="{ row }" slot="movie_name">
          <span style="cursor: pointer;" @click="getDetail(row)">
            <span style="color: #0099FF;text-decoration: underline;">{{row.movie_name}}</span>
            <span v-if="row.isChangeSeat == true" style="color: #FF8622;">(已调座)</span>
          </span>
        </template>
        <template slot-scope="{ row }" slot="commissionRate" >
          <span v-if="row.source_type != 2">{{row.commissionRate}}%</span>
          <div v-else style="text-align: center"> - </div>
        </template>
        <template slot-scope="{ row }" slot="app_commission" >
          <span v-if="row.source_type != 2">{{row.app_commission}}</span>
          <div v-else style="text-align: center"> - </div>
        </template>
        <template slot-scope="{ row }" slot="order_price" >
          <span v-if="row.source_type == 2">{{row.order_price}}</span>
          <div v-else style="text-align: center"> - </div>
        </template>
        <template slot-scope="{ row }" slot="deductionRatio" >
          <span v-if="row.source_type == 2">{{(row.order_price/row.init_price).toFixed(3)}}</span>
          <div v-else style="text-align: center"> - </div>
        </template>
<!--        <template slot-scope="{ row }" slot="handle">-->
<!--          <div class="tableHandleStyle">-->
<!--            <span class="intercept" v-if="row.canIntercept" @click="interceptBtn(row)">拦截订单</span>-->
<!--            <span class="urge" v-if="row.canCuiTicket" @click="urgeBill(row)">催出票</span>-->
<!--            &lt;!&ndash; <span class="urge" v-if="row.canCuiTicket == false">已催</span> &ndash;&gt;-->
<!--            <span class="close" v-if="row.canCancelIntercept" @click="cancelOrderBtn(row)">取消拦截</span>-->
<!--          </div>-->
<!--        </template>-->
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.page" show-sizer show-elevator show-total @on-change="changePage"
              @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <Detail ref='Detail'></Detail>

    <!--取消拦截-->
    <el-dialog title="取消拦截" :visible.sync="dialog_close" width="500px">
      <div class="dialog-content">确认取消拦截？</div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_close = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_closeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--取消拦截-->
    <!--拦截订单-->
    <el-dialog title="拦截订单" :visible.sync="dialog_intercept" width="460px">
      <div class="dialog-content">
        <div class="box">
          <div style="margin-right: 16px;"><span>*</span>拦截原因</div>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入拦截原因" v-model="interceptReason" style="flex: 1;">
          </el-input>
        </div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_intercept = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_interceptBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--拦截订单-->
    <!--    拦截成功提示-->
    <el-dialog
      title="提示"
      :visible.sync="hintShow"
      width="40%"
      :before-close="handleClose">
      <div class="dialog-content">
        <div>
          <div class="dialog-text">已发起拦截。不保证拦截成功，<span style="color: red">请稍后刷新页面查看结果</span></div>
        </div>
        <div class="dialogFooter" style="margin-left: auto;margin-right: 40px;margin-top: 50px">
          <div class="dialogFooter-ok" @click="hintShow = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <!--催出票-->
    <el-dialog title="催出票" :visible.sync="dialog_urge" width="460px">
      <div class="dialog-content">
        <div class="hint">确定催促出票？</div>
        <div class="placeholder">每个订单10分钟内只能发起一次催出票。</div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_urge = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_urgeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--催出票-->
  </div>
</template>
<script>
import questionBtn from '@/assets/img/promotion/btn_doubt.png'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker, Tooltip } from 'view-design'
import { getOrderList, orderExport } from '@/api/order'
import { getDate } from '@/utils/date'
import { getToken, getPlatformName, getHeadImg } from '@/utils/auth'
import Detail from '@/views/pc/promotion/order/modal/Detail'
import Vue from 'vue'
import order from '@/javaApi/order'
const orderModel = new order()
Vue.component('Tooltip', Tooltip)
export default {
  name: 'PromotionOrder',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Detail
  },
  data: function() {
    return {
      platformName: getPlatformName(),
      headImg: getHeadImg(),
      dialog_close: false,
      dialog_intercept: false,
      dialog_urge: false,
      interceptReason: '',
      activeRow: {},
      columns: [
        // {
        //   title: '影票信息',
        //   key: 'movie_pic',
        //   fixed: 'left',
        //   width: 280,
        //   render: (h, params) => {
        //     let movieName = params.row.movie_name
        //     let movieImage = params.row.movie_pic
        //     let orderTime = params.row.order_create_time
        //     let renderData = []
        //     if(movieImage) {
        //       renderData.push(
        //         h('img',{
        //             attrs:{
        //               src: movieImage, style: 'width: 30%;height: auto;margin:20px;float:left;cursor:pointer;'
        //             },
        //         })
        //       )
        //     }
        //     renderData.push(
        //       h('span', {
        //         attrs: {
        //           style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
        //         }
        //       }, movieName)
        //     ),
        //     renderData.push(
        //       h('span', {
        //         attrs: {
        //           style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
        //         }
        //       }, orderTime)
        //     )
        //     return renderData
        //   }
        // },
        {
          title: '影票信息',
          key: 'movie_name',
          slot: 'movie_name',
          fixed: 'left',
          width: 200,
          // render: (h, params) => {
          //   let movieName = params.row.movie_name
          //   let renderData = []
          //   renderData.push(
          //     h('span', {
          //       attrs: {
          //         style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
          //       }
          //     }, movieName)
          //   )
          //   return renderData
          // }
        },
        {
          title: '守兔订单编号',
          key: 'order_id',
          width: 180,
        },
        {
          title: '第三方订单',
          key: 'third_order_id',
          width: 180,
        },
        {
          title: '市场价',
          key: 'init_price',
          width: 120,
        },
        {
          title: '数量',
          key: 'order_num',
          width: 80,
        },
        // {
        //   title: '用户支付金额',
        //   key: 'order_price',
        //   width: 140,
        // },
        // {
        //   title: '成本价',
        //   key: 'order_price',
        //   slot: 'order_price',
        //   width: 120,
        // },
        // {
        //   title: '成本折扣',
        //   key: 'deductionRatio',
        //   slot: 'deductionRatio',
        //   width: 120,
        // },
        // {
        //   title: '订单总佣金',
        //   key: 'app_commission',
        //   slot: 'app_commission',
        //   width: 120,
        // },
        // {
        //   title: '推广佣金',
        //   key: 'app_commission',
        //   width: 120,
        // },
        // {
        //   title: '佣金比例',
        //   key: 'commissionRate',
        //   slot: 'commissionRate',
        //   width: 120,
        // },

        {
          title: '订单来源',
          key: 'source_type_str',
          width: 120,
        },
        // {
        //   title: '市场价',
        //   key: 'init_price',
        //   width: 120,
        // },

        // {
        //   title: '推广位',
        //   key: 'app_key',
        //   width: 120,
        // },
        {
          title: '下单时间',
          key: 'order_create_time',
          width: 180,
        },
        // {
        //   title: '放映时间',
        //   key: 'show_time',
        //   width: 180,
        // },
        {
          title: '结算时间',
          key: 'settle_time',
          renderHeader: (h, params) => {
            return h('Tooltip', {
                props: {
                  transfer: true,
                  placement: 'bottom-end' //下右
                }
              },
              [
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  '影票放映后7天内结算'
                ),
                h('div', [
                  h('span', {
                    domProps: {
                      innerHTML: '结算时间'
                    }
                  }),
                  h('img', {
                    attrs: {
                      src: questionBtn
                    },
                    style: {
                      width: '30px'
                    }
                  })
                ])
              ]
            )
          },
          width: 180
        },
        {
          title: '拦截状态',
          key: 'interceptStatusStr',
          width: 120
        },
        {
          title: '订单状态',
          key: 'order_status_str',
          width: 120
        },
        // {
        //   title: '操作',
        //   key: 'handle',
        //   slot: 'handle',
        //   width: 222
        // }
      ],
      listLoading: false,
      status_list: [],
      // list: [],
      testlist: [
        {
          handle: 1
        }
      ],
      list: [],
      total: 0,
      appList: [],
      interceptStatus: [
        { label: '全部', value: '' },
        { label: '未拦截', value: '0' },
        { label: '拦截中', value: '3' },
        { label: '拦截成功', value: '1' },
        { label: '拦截失败', value: '2' },
      ],
      searchForm: {
        page: 1,
        pagesize: 10,
        order_status: '',
        order_id: '',
        start_time_bak: '',
        end_time_bak: '',
        start_time: '',
        end_time: '',
        sort: '-id',
        app_key: '',
        orderType:1,
        third_order_id:''
      },
      hintShow:false
    }
  },
  computed:{
    path:{
      get(){
        return this.$route.path
      }
    }
  },
  created() {
    // 判断是否高亮
    if(this.path === '/pc/bypassAccountOrder/ApiOrder'){
      this.$parent.isActive = 0
    }
    this.getList(true)
  },
  methods: {
    urgeBill(row) {
      console.log('row', row)
      this.dialog_urge = true
      this.activeRow = row
    },
    dialog_urgeBtnOk() {
      orderModel
        .urgeBill({
          orderUUID: this.activeRow.orderUUID,
        })
        .then(res => {
          console.log('res',res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_urge = false
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    dialog_interceptBtnOk() {
      orderModel
        .InterceptOrder({
          orderUUID: this.activeRow.orderUUID,
          interceptReason: this.interceptReason,
          // applicantName: this.platformName,
          applicantName: '开放平台',
          applicantUrl: this.headImg
        })
        .then(res => {
          console.log('res',res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_intercept = false
            this.hintShow = true
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    dialog_closeBtnOk() {
      orderModel
        .cancelOrder({
          orderUUID: this.activeRow.orderUUID
        })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_close = false
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    interceptBtn(row) {
      this.interceptReason = ''
      console.log('row', row)
      this.dialog_intercept = true
      this.activeRow = row
    },
    cancelOrderBtn(row) {
      console.log('row', row)
      this.dialog_close = true
      this.activeRow = row
    },
    tableHandle_close() {
      this.dialog_close = true
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      getOrderList(searchForm)
        .then(response => {
          this.listLoading = false
          if (response.code != 200) {
            this.$Message.error(response.msg)
            return
          }
          this.list = response.data.list
          console.log('list',this.list)
          this.total = response.data.total
          if (searchForm.page == 1) {
            this.status_list = response.data.status_list
            this.appList = response.data.appList
          }
        })
        .catch(error => {
          this.listLoading = false
          console.log(error)
        })
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      } else {
        return 'bg-white'
      }
    },
    handleFilter() {
      console.log(this.searchForm)
      this.getList(true)
    },
    // 重置
    reset() {
      console.log("debug:________________start_time______________");
      this.searchForm.order_status = ''
      this.searchForm.order_id = ''
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.searchForm.app_key = ''
      this.searchForm.interceptStatus = ''
      this.searchForm.start_time_bak = ''
      this.searchForm.end_time_bak = ''
      this.searchForm.orderType = ''
      this.searchForm.third_order_id = ''
      this.getList()
    },
    changePage(value) {
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pagesize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList()
      }
    },
    handelDateChange: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.start_time_bak !== '') {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.end_time_bak !== '') {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    downReport: async function () {
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak

      const exportParams = {
        order_status:searchForm.order_status,
        order_id: searchForm.order_id,
        start_time: searchForm.start_time,
        end_time:searchForm.end_time,
        token: getToken()
      }
      const res = await orderExport(exportParams)
      const message = res.message
      const code = res.code
      if(code === 200){
        await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
          showCancelButton: true,
          confirmButtonText: '前往导出列表',
          cancelButtonText: '取消',
          callback: action => {
            if(action === 'confirm'){
              this.$router.push({ path: "/pc/exportCenter/index" });
            }
            this.exportLoading = false
          }
        });
      }else{
        this.$Message.error(message);
        this.exportLoading = false
      }
    },
    getDetail: function (row) {
      this.$refs.Detail.init(true, row)
    },
    handleClose(){
      this.hintShow = false
    },
    selectType(e){
      this.searchForm.orderType = e
      this.getList()
    }
  }
}
</script>
<style scoped lang="less">
/deep/.el-dialog__body {
  padding: 0;
  padding-bottom: 20px;
}
.flex {
  display: flex;
  align-items: center;
}
.dialog-content {
  min-height: 120px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 25px;
    span {
      color: red;
    }
    // margin-top: 30px;
  }
  .hint {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }
  .placeholder {
    margin-top: 10px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.dialogFooter {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  div {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .dialogFooter-ok {
    background-color: #ff8622;
    color: #ffffff;
  }
}
.tableHandleStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff9734;
  span {
    cursor: pointer;
  }
  .intercept {
    color: #ff9734;
  }
  .urge {
    color: #3d9efc;
  }
  .close {
    color: #ff4f76;
  }
}
.wrapper {
  width: 100%;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 1.12rem;
}

.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
  display: inline-block;
  padding-right: 7px;
}

.table-wrapper .show-excel:last-child {
  padding-right: 0px;
}

.table-wrapper .status-text-success {
  font-size: 14px;
  color: #3d9efc;
}

.table-wrapper .status-text-reject {
  font-size: 14px;
  color: #ff8622;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: '\F33D';
}
.search-text{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/ApiOrder.vue